export default function LocationPinLocked() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Location pin locked icon</title>
      <path
        d="M13.07 16.0837C14.7842 16.0837 16.1737 14.6941 16.1737 12.98C16.1737 11.2658 14.7842 9.87622 13.07 9.87622C11.3558 9.87622 9.96625 11.2658 9.96625 12.98C9.96625 14.6941 11.3558 16.0837 13.07 16.0837Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3612 13.655C22.5237 11.0787 21.6287 8.44875 19.66 6.48C16.02 2.84 10.12 2.84 6.48 6.48C2.84 10.12 2.84 16.02 6.48 19.66L13.07 26.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9552 21.0325V19.1418C23.9552 17.9594 22.9958 17 21.8135 17C20.6311 17 19.6717 17.9594 19.6717 19.1418V21.0325"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.268 21.0339H19.3589C18.5847 21.0339 17.9563 21.6622 17.9563 22.4365V25.4156C17.9563 26.1898 18.5847 26.8182 19.3589 26.8182H24.268C25.0422 26.8182 25.6706 26.1898 25.6706 25.4156V22.4365C25.6706 21.6622 25.0422 21.0339 24.268 21.0339Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
